import React, { useState, useRef } from 'react'

import { useHistory } from 'react-router-dom'
import { Box, Button, Grid } from '@material-ui/core'
import {
  HelpCircle as HelpCircleIcon,
  Link as LinkIcon,
  PlusCircle as PlusCircleIcon,
} from 'react-feather'

import {
  Container,
  ContentHeader,
  DriveTour,
  Page,
  Permitted,
} from 'components'

import {
  ExternalLinkDialog,
  Filters,
  MySuppliersTable,
  ProgressStatsCards,
} from '../components'

import useFilter from 'hooks/useFilter'

import { routes } from 'Routes'
import constants from 'constants/index'
import permissions from 'constants/permissions'
import theme from 'theme'

const ThirdPartyManagementMySuppliers = () => {
  const [openTour, setOpenTour] = useState(false)
  const [openExternalLink, setOpenExternalLink] = useState(false)
  const statsCardsRef = useRef(null)

  const history = useHistory()
  const filter = useFilter()

  const { STEPS, STEPS_OBJECT } = constants.tours.thirdPartyManagements

  const handleRedirect = () =>
    history.push(routes.thirdPartyManagements.mySuppliers.new)

  const handleOpenTour = () => setOpenTour(true)

  const handleRefreshStats = () => statsCardsRef.current?.refresh()

  return (
    <Page title="Gestão de Fornecedores - Meus Fornecedores">
      <Container maxWidth={false}>
        <ContentHeader title="Meus Fornecedores">
          <Button
            id={STEPS.MY_SUPPLIERS[1]}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
          >
            Tutorial
          </Button>

          <Permitted
            someTags={[
              permissions.COMPANY_SUPPLIERS.SHOW,
              permissions.COMPANY_SUPPLIERS.UPDATE,
            ]}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<LinkIcon size={20} />}
              onClick={() => setOpenExternalLink(true)}
            >
              Link Externo
            </Button>
          </Permitted>

          <Permitted tag={permissions.COMPANY_SUPPLIERS.UPDATE}>
            <Button
              id={STEPS.MY_SUPPLIERS[2]}
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={handleRedirect}
            >
              Criar
            </Button>
          </Permitted>

          <Filters filter={filter} />
        </ContentHeader>
        <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
          <ProgressStatsCards ref={statsCardsRef} filter={filter} />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MySuppliersTable
                filter={filter}
                onRefreshStats={handleRefreshStats}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>

      <ExternalLinkDialog
        open={openExternalLink}
        setOpen={setOpenExternalLink}
      />

      <DriveTour
        stepsMatrix={STEPS_OBJECT.MY_SUPPLIERS}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ThirdPartyManagementMySuppliers
